<template>
    <section class="home-container">
        <MasterPage title="患者检测订单">
            <div slot="title-icon">
                <Icon type="ios-albums" />
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="infoModel" title="检测订单详情" width="50%">
            <Form :label-width="100">
                <Row>
                    <Col span="12">
                    <FormItem  label="订单ID：">
                        {{infoItem.id}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="患者用户：">
                        <span v-for="item in userAllList" v-if="item.id === infoItem.userId" :key="item.id">
                            {{item.name}}
                        </span>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="检测项目名称：">
                        {{infoItem.testName}}
                    </FormItem>
                    </Col>
                    <Col span="24">
                    <FormItem label="检测项目介绍：">
                        <div style="white-space: pre-wrap">{{infoItem.testIntroduction}}</div>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="订单总价：">
                        {{infoItem.amount}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="订单状态：">
                        {{infoItem.status}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="收件人姓名：">
                        {{infoItem.connectName}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="联系电话：">
                        {{infoItem.connectPhone}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="快递地址：">
                        {{infoItem.connectAddress}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="快递名称：">
                        {{infoItem.expressType}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="快递单号：">
                        {{infoItem.expressNumber}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="报告结果：">
                        <Button v-for="file in infoItem.resultUrl" :key="file.url"
                                type="info" icon="md-cloud-download" style="margin: 0 5px" @click="uploadItem(file)">
                            下载{{file.fileName}}
                        </Button>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="取消原因：">
                        {{infoItem.cancelReason}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="备注：">
                        {{infoItem.remark}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem  label="下单时间：">
                        {{infoItem.createTime | dateTimeToString}}
                    </FormItem>
                    </Col>
                </Row>
            </Form>
        </Modal>
        <Modal v-model="updateSendModel" title="检测订单确认" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="快递名称：">
                    <Input v-model="updateInfoItem.expressType" placeholder="请输入" />
                </FormItem>
                <FormItem label="快递单号：">
                    <Input v-model="updateInfoItem.expressNumber" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateSendLoading" @click="updateSendItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateComplteModel" title="检测订单完成" @on-cancel="cancelItem">
            <Form :label-width="100">
                <Row v-for="file in updateInfoItem.resultUrl" :key="file.url" style="margin-bottom: 5px">
                    <Col span="12"><span style="line-height: 30px;">{{file.fileName}}</span></Col>
                    <Col span="12">
                    <Button type="warning" @click="deleteFile(file.url)">删除</Button>
                    </Col>
                </Row>
            </Form>
            <Upload
                    ref="uploadImage"
                    multiple
                    type="drag"
                    :before-upload="fileBefore"
                    :on-success="fileSuccess"
                    :on-error="fileError"
                    action="food/file/upload">
                <div :style="{padding:'30px 0'}">
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>单击或拖动文件以上传</p>
                </div>
            </Upload>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateComplteLoading" @click="updateCompltetItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateDeleteModel" title="检测订单取消" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="取消原则：">
                    <Input v-model="updateInfoItem.cancelReason" placeholder="请输入" />
                </FormItem>、
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateDeleteLoading" @click="deleteItem">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '患者用户',
                        align: 'center',
                        render: (h, params) => {
                            return h('span', this.currentPatient.name)
//                            for (let i in this.userAllList) {
//                                if (this.userAllList[i].id === params.row.userId) {
//                                    return h('span', this.userAllList[i].name)
//                                }
//                            }
                        }
                    },
                    {
                        title: '检测项目',
                        key: 'testName',
                        align: 'center',
                    },
                    {
                        title: '订单总价',
                        key: 'amount',
                        align: 'center',
                    },
                    {
                        title: '订单状态',
                        key: 'status',
                        align: 'center',
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            switch (params.row.status) {
                                case '已下单':
                                    Buttons.push(
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                icon:'md-create',
                                                label:"small",
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.updateTureItem_modal(this.dataList[params.index])
                                                }
                                            }
                                        }, '确认')
                                    )
                                    Buttons.push(
                                        h('Button', {
                                            props: {
                                                type: 'error',
                                                icon:'md-trash',
                                                label:"small",
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.updateDeleteModel = true
                                                    this.updateInfoItem = JSON.parse(JSON.stringify(this.dataList[params.index]))
                                                }
                                            }
                                        }, '取消')
                                    )
                                    break
                                case '已确认':
                                    Buttons.push(
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                icon:'md-create',
                                                label:"small",
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.updateSendModel = true
                                                    this.updateInfoItem = JSON.parse(JSON.stringify(this.dataList[params.index]))
                                                }
                                            }
                                        }, '发货')
                                    )
                                    Buttons.push(
                                        h('Button', {
                                            props: {
                                                type: 'error',
                                                icon:'md-trash',
                                                label:"small",
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.updateDeleteModel = true
                                                    this.updateInfoItem = JSON.parse(JSON.stringify(this.dataList[params.index]))
                                                }
                                            }
                                        }, '取消')
                                    )
                                    break
                                case '已发货':
                                    Buttons.push(
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                icon:'md-create',
                                                label:"small",
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.updateComplteModel = true
                                                    this.updateInfoItem = JSON.parse(JSON.stringify(this.dataList[params.index]))
                                                    this.updateInfoItem.resultUrl = []
                                                }
                                            }
                                        }, '完成')
                                    )
                                    break
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                userAllList: [],
                medicalObjectAllList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                updateSendModel: false,
                updateSendLoading: false,
                updateComplteModel:false,
                updateComplteLoading:false,
                updateDeleteModel: false,
                updateDeleteLoading: false,
                select:{
                    userId:'',
                    testId:'',
                    status:'已下单',
                },
                updateInfoItem:"",
                infoItem:'',
                fileName:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                currentPatient: null
            }
        },
        created(){
//            this.findAllUser()
            this.currentPatient = this.$route.params.patient
            console.log('patient', this.currentPatient)
            this.findAllmedicalObject()
            this.pageFindItem()
        },
        methods:{
            fileBefore(file){
                this.$refs.uploadImage.clearFiles()
                if (file.size > 1024*1024*40) {
                    this.$Message.warning('文件大小请勿超过40M');
                    return false
                }
                this.fileName = file.name.substr(0,file.name.lastIndexOf('.'))
                return true
            },
            fileSuccess(response){
                this.$Notice.success({title:'文件上传成功'});
                let fileList = {url: response.data.replace(/\\/g,"/"), fileName: this.fileName}
                this.updateInfoItem.resultUrl.push(fileList)
            },
            fileError(error){
                this.$Notice.error({title:'文件上传失败',desc: error.message});
            },
            deleteFile (url) {
                for (let i in this.updateInfoItem.resultUrl) {
                    if (url === this.updateInfoItem.resultUrl[i].url){
                        return this.updateInfoItem.resultUrl.splice(i, 1)
                    }
                }
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllmedicalObject(){
                this.$http.post('test/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.medicalObjectAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'检查项目查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('test/listOrder',{
                    userId: this.currentPatient.id,
                    testId: this.select.testId?this.select.testId:'',
                    status: this.select.status,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list.map(f => {
                            f.resultUrl = JSON.parse(f.resultUrl)
                            return f
                        })
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'检测订单列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            updateTureItem_modal(item){
                this.$Modal.confirm({
                    title: '确认检测订单',
                    loading:true,
                    onOk: () => {
                        this.updateTureItem(item);
                    }
                });
            },
            updateTureItem(item){
                this.$http.post('test/updateOrder',{
                    orderId: item.id,
                    status: '已确认',
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.$Modal.remove()
                        this.$Notice.success({title: '检测订单确认成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检测订单确认失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            updateSendItem(){
                if (this.updateInfoItem.expressType == null || this.updateInfoItem.expressType.length <= 0){
                    return this.$Message.warning('请输入快递名称');
                }
                if (this.updateInfoItem.expressNumber == null || this.updateInfoItem.expressNumber.length <= 0){
                    return this.$Message.warning('请输入快递单号');
                }
                this.updateSendLoading = true
                this.$http.post('test/updateOrder',{
                    orderId: this.updateInfoItem.id,
                    status: '已发货',
                    expressType: this.updateInfoItem.expressType,
                    expressNumber: this.updateInfoItem.expressNumber
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检测订单发货成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检测订单发货失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateCompltetItem() {
                if (this.updateInfoItem.resultUrl <= 0){
                    return this.$Message.warning('请上传检查订单报告');
                }
                this.updateComplteLoading = true
                this.$http.post('test/updateOrder',{
                    orderId: this.updateInfoItem.id,
                    status: '已完成',
                    resultUrl: JSON.stringify(this.updateInfoItem.resultUrl)
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检测订单完成成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检测订单完成失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel =  this.updateModel = this.infoModel = this.updateDeleteModel = this.updateSendModel = this.updateComplteModel = false
                this.addLoading =this.updateLoading = this.updateDeleteLoading = this.updateSendLoading = this.updateComplteLoading = false
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            deleteItem(){
                if (this.updateInfoItem.cancelReason == null || this.updateInfoItem.cancelReason.length <= 0){
                    return this.$Message.warning('请输入取消原因');
                }
                this.updateDeleteLoading = true
                this.$http.post('test/updateOrder',{
                    orderId:this.updateInfoItem.id,
                    status: '已取消',
                    reason:this.updateInfoItem.cancelReason,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '检测订单取消成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'检测订单取消失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            uploadItem(item){
                var eleLink = document.createElement('a')
                eleLink.href = this.baseURL + item.url
                eleLink.download = item.fileName
                eleLink.target = '_blank'
                eleLink.style.display = 'none'
                document.body.appendChild(eleLink)
                eleLink.click()
                document.body.removeChild(eleLink)
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


